var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsdtIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_3117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.982 14.9961C24.982 20.4917 20.5273 24.9464 15.0318 24.9464C9.53647 24.9464 5.08154 20.4917 5.08154 14.9961C5.08154 9.50072 9.53647 5.0459 15.0318 5.0459C20.5273 5.0459 24.982 9.50072 24.982 14.9961Z",
    fill: "#1BA27A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7017 10.0635H10.2798V12.3381H13.8534V15.6814H16.128V12.3381H19.7017V10.0635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0125 16.0377C12.0563 16.0377 9.65957 15.5699 9.65957 14.9927C9.65957 14.4156 12.0562 13.9476 15.0125 13.9476C17.9687 13.9476 20.3653 14.4156 20.3653 14.9927C20.3653 15.5699 17.9687 16.0377 15.0125 16.0377ZM21.0229 15.1669C21.0229 14.4226 18.332 13.8193 15.0125 13.8193C11.6931 13.8193 9.00195 14.4226 9.00195 15.1669C9.00195 15.8223 11.0886 16.3684 13.8537 16.4894V21.2888H16.1281V16.4913C18.9145 16.3741 21.0229 15.8257 21.0229 15.1669Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_3117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtIcon);
export default __webpack_public_path__ + "static/media/usdt-icon.4c24159e08aaa9b84e0964729cc6e175.svg";
export { ForwardRef as ReactComponent };